import { render, staticRenderFns } from "./image.vue?vue&type=template&id=63b4cf04&"
import script from "./image.vue?vue&type=script&lang=ts&"
export * from "./image.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports